











import auth from "@/services/auth";
import { Component, Vue, Inject } from "vue-property-decorator";
import Footer from "../components/Footer.vue";
import AbpBase from "../lib/abpbase";
import Util from "../lib/util";
@Component({
  components: { Footer },
})
export default class Error403 extends AbpBase {
  logout() {
    this.$store.commit("app/logout", this);
    Util.abp.auth.clearToken();
    Util.abp.multiTenancy.setTenantIdCookie(null);
    sessionStorage.setItem("isAuth", "false");
    auth.silentLogout();
    location.replace("/")
  }
}
